import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { acosClamped as t, clamp as n } from "../../../core/mathUtils.js";
import { s as i, d as o, n as s, c as r, l as a, a as c, b as h, e, f as u } from "../../../chunks/vec3.js";
import { c as f } from "../../../chunks/vec3f64.js";

function m(t, n) {
  return t > n ? Math.cos(n) : Math.cos(t);
}

function M(t, n, i) {
  return 2 * Math.atan(i * Math.tan(.5 * t) / n);
}

function l(t, n, i) {
  return 2 * Math.atan(n * Math.tan(.5 * t) / i);
}

function d(t) {
  var n = t[0] * t[0] + t[4] * t[4] + t[8] * t[8],
      i = t[1] * t[1] + t[5] * t[5] + t[9] * t[9],
      o = t[2] * t[2] + t[6] * t[6] + t[10] * t[10];
  return Math.sqrt(Math.max(n, i, o));
}

function z(t, n) {
  var o = Math.sqrt(n[0] * n[0] + n[4] * n[4] + n[8] * n[8]),
      s = Math.sqrt(n[1] * n[1] + n[5] * n[5] + n[9] * n[9]),
      r = Math.sqrt(n[2] * n[2] + n[6] * n[6] + n[10] * n[10]);
  return i(t, o, s, r), t;
}

function b(t, n, r) {
  r = r || t;
  var a = o(t, n);
  i(r, t[0] - a * n[0], t[1] - a * n[1], t[2] - a * n[2]), s(r, r);
}

function g(t, n, o) {
  Math.abs(t[0]) > Math.abs(t[1]) ? i(n, 0, 1, 0) : i(n, 1, 0, 0), r(o, t, n), s(n, n), r(n, o, t), s(o, o);
}

function p(t, n) {
  return (t % n + n) % n;
}

function x(t, n, i, o, s, r) {
  var a = t + (n - t) * s;
  return a + (i + (o - i) * s - a) * r;
}

function q(t, n, i) {
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : f();
  var r = a(t),
      u = a(n),
      m = o(t, n) / (r * u);

  if (m < .9999999999999999) {
    var _o = Math.acos(m),
        _a = ((1 - i) * r + i * u) / Math.sin(_o),
        _e = _a / r * Math.sin((1 - i) * _o),
        _f = _a / u * Math.sin(i * _o);

    return c(A, t, _e), c(B, n, _f), h(s, A, B);
  }

  return e(s, t, n, i);
}

function j(t, n, i) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : f();
  var m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : f();
  var M = a(t),
      l = a(n),
      d = o(t, n) / (M * l);

  if (d < .9999999999999999) {
    var _o2 = Math.acos(d),
        _s = Math.sin(_o2),
        _a2 = Math.sin(i * _o2),
        _e2 = Math.sin((1 - i) * _o2),
        _u = (1 - i) * M + i * l;

    {
      var _i = _u / _s,
          _o3 = _i / l * _a2;

      c(A, t, _i / M * _e2), c(B, n, _o3), h(r, A, B);
    }
    {
      var _r = 1 / M * (-Math.cos((1 - i) * _o2) * _o2 * _u + _e2 * (-M + l));

      c(A, t, _r);

      var _f2 = 1 / l * (Math.cos(i * _o2) * _o2 * _u + _a2 * (-M + l));

      c(B, n, _f2), h(m, A, B), c(m, m, 1 / _s);
    }
    return m;
  }

  return e(r, t, n, i), u(m, n, t), s(m, m), m;
}

function w(n, i, a) {
  n = s(A, n), i = s(B, i);
  var c = t(o(n, i));

  if (a) {
    var _t = r(y, n, i);

    if (o(_t, a) < 0) return -c;
  }

  return c;
}

function I(t) {
  var n = t.length;
  return function (i) {
    if (i <= t[0][0]) return t[0][1];
    if (i >= t[n - 1][0]) return t[n - 1][1];
    var o = 1;

    for (; i > t[o][0];) {
      o++;
    }

    var s = t[o - 1][0],
        r = t[o][0],
        a = (r - i) / (r - s);
    return a * t[o - 1][1] + (1 - a) * t[o][1];
  };
}

var P = /*#__PURE__*/function () {
  function P(t, n) {
    _classCallCheck(this, P);

    this.min = t, this.max = n, this.range = n - t;
  }

  _createClass(P, [{
    key: "ndiff",
    value: function ndiff(t) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return Math.ceil((t - n) / this.range) * this.range + n;
    }
  }, {
    key: "_normalize",
    value: function _normalize(t, n, i) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      return (i -= o) < t ? i += this.ndiff(t - i) : i > n && (i -= this.ndiff(i - n)), s && i === n && (i = t), i + o;
    }
  }, {
    key: "normalize",
    value: function normalize(t) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return this._normalize(this.min, this.max, t, n, i);
    }
  }, {
    key: "clamp",
    value: function clamp(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return n(t - i, this.min, this.max) + i;
    }
  }, {
    key: "monotonic",
    value: function monotonic(t, n, i) {
      return t < n ? n : n + this.ndiff(t - n, i);
    }
  }, {
    key: "minimalMonotonic",
    value: function minimalMonotonic(t, n, i) {
      return this._normalize(t, t + this.range, n, i);
    }
  }, {
    key: "center",
    value: function center(t, n, i) {
      return n = this.monotonic(t, n, i), this.normalize((t + n) / 2, i);
    }
  }, {
    key: "diff",
    value: function diff(t, n, i) {
      return this.monotonic(t, n, i) - t;
    }
  }, {
    key: "shortestSignedDiff",
    value: function shortestSignedDiff(t, n) {
      t = this.normalize(t);
      var i = (n = this.normalize(n)) - t,
          o = n < t ? this.minimalMonotonic(t, n) - t : n - this.minimalMonotonic(n, t);
      return Math.abs(i) < Math.abs(o) ? i : o;
    }
  }, {
    key: "contains",
    value: function contains(t, n, i) {
      return n = this.minimalMonotonic(t, n), (i = this.minimalMonotonic(t, i)) > t && i < n;
    }
  }]);

  return P;
}();

function _(t, n, i, a) {
  u(k, n, t), u(v, i, t), r(a, k, v), s(a, a), a[3] = -o(t, a);
}

var k = f(),
    v = f();

function D(t) {
  for (var _n in t) {
    var _i2 = t[_n];
    _i2 instanceof Function && (t[_n] = _i2.bind(t));
  }

  return t;
}

var F = D(new P(0, 2 * Math.PI)),
    S = D(new P(-Math.PI, Math.PI)),
    U = D(new P(0, 360)),
    y = f(),
    A = f(),
    B = f();
export { P as Cyclical, w as angle, x as bilerp, m as cosCapped, F as cyclical2PI, U as cyclicalDeg, S as cyclicalPI, M as fovx2fovy, l as fovy2fovx, b as makeOrthonormal, I as makePiecewiseLinearFunction, d as maxScale, p as moduloPositive, _ as planeFromPoints, z as scaleFromMatrix, q as slerp, j as slerpTangent, g as tangentFrame };